module.exports = __webpack_public_path__ + "img/acredo_logo.c73ba8a.svg";